const $ = jQuery

export default function Navigation() {
  const HEADER = document.querySelector('.dm-header')
  if (!HEADER) return

  const LOGO = HEADER.querySelector('.dm-header__logo')
  const OVERLAY = HEADER.querySelector('.dm-header__overlay')
  const NAV_ICON = HEADER.querySelector('.dm-header__nav-icon')
  const LINKS = HEADER.querySelectorAll('.dm-header__list-anchor')

  const iconOpenCls = 'open'
  const headerOpenCls = 'dm-header--open'

  NAV_ICON && NAV_ICON.addEventListener('click', toggleNav)
  OVERLAY && OVERLAY.addEventListener('click', closeNav)

  if (LINKS.length > 0) {
    for (let i = 0; i < LINKS.length; i++) {
      const LINK = LINKS[i]
      LINK.addEventListener('click', (e) => {
        e.preventDefault()
        scrollToElement(LINK)
        if (getScreenWidth() <= 960) closeNav()
      })
    }
  }

  LOGO && LOGO.addEventListener('click', (e) => {
    e.preventDefault()
    const href = LOGO.getAttribute('href')
    if (href === '#') {
      $('html, body').animate({
        scrollTop: 0
      }, 800)
    } else {
      window.location.href = href
    }
  })

  function toggleNav() {
    NAV_ICON.classList.toggle(iconOpenCls)
    HEADER.classList.toggle(headerOpenCls)
  }

  function closeNav() {
    NAV_ICON.classList.remove(iconOpenCls)
    HEADER.classList.remove(headerOpenCls)
  }
}

function scrollToElement(EL) {
  const href = EL.getAttribute('href')
  const id = href ? href.replace('#', '') : ''
  const ELEMENT = document.getElementById(id)
  if (!ELEMENT) return

  $('html, body').animate({
    scrollTop: $(ELEMENT).offset().top - getHeaderHeight()
  }, 800)
}

function getHeaderHeight() {
  let height = 0
  const HEADER = document.querySelector('.dm-header')
  HEADER && (height += HEADER.getBoundingClientRect().height)
  const ADMIN_BAR = document.getElementById('wpadminbar')
  ADMIN_BAR && (height += ADMIN_BAR.getBoundingClientRect().height)
  return height
}

function getScreenWidth() {
  return window.innerWidth || document.documentElement.clientWidth || document.body.clientWidth
}